import routes from "./routes";
import { Suspense } from "react";

import {
	Routes,
	Route,
	useNavigate,
	useLocation,
	useParams,
	useSearchParams,
} from "react-router-dom";

const Element = function (props) {
	let { component: Component } = props;
	// 获取路由信息
	const navigate = useNavigate();
	const location = useLocation();
	const params = useParams();
	const [usp] = useSearchParams();

	return (
		<Component
			navigate={navigate}
			location={location}
			params={params}
			usp={usp}
		/>
	);
};

const CreateRoute = function (routes) {
	return (
		<>
			{routes.map((item, index) => {
				let { path, children } = item;

				return (
					<Route
						key={index}
						path={path}
						element={<Element {...item} />}>
						{Array.isArray(children) ? CreateRoute(children) : null}
					</Route>
				);
			})}
		</>
	);
};

export default function RouterView() {
	return (
		<Suspense
			fallback={
				<div className="g-loading">
					<p>Loading</p>
				</div>
			}>
			<Routes>{CreateRoute(routes)}</Routes>
		</Suspense>
	);
}

export const withRouter = function (Component) {
	return function HOC(props) {
		const navigate = useNavigate();
		const location = useLocation();
		const params = useParams();
		const [usp] = useSearchParams();
		return (
			<Component
				{...props}
				navigate={navigate}
				location={location}
				params={params}
				usp={usp}
			/>
		);
	};
};
